export const sidebarMenus = [
  {
    index: 1,
    icon: "home",
    label: "Home",
  },
  {
    index: 2,
    icon: "user",
    label: "About",
  },
  {
    index: 3,
    icon: "poo",
    label: "Resume",
  },
  {
    index: 4,
    icon: "eye",
    label: "Projects",
  },
  {
    index: 5,
    icon: "newspaper-o",
    label: "Blogs",
  },
  {
    index: 6,
    icon: "envelope",
    label: "Contact",
  },
];

export const sidebarSocialLinks = [
  {
    index: 1,
    icon: "facebook",
  },
  {
    index: 2,
    icon: "twitter",
  },
  {
    index: 3,
    icon: "github",
  },
  {
    index: 4,
    icon: "linkedin",
  },
  {
    index: 5,
    icon: "stack-overflow",
  },
];
